// hero-home

  /* Rotating relationship word.
     ONE interval, keyed to Date.now(), so a backgrounded tab resumes on the
     correct word instead of freezing mid-fade on a blank one. Every word is
     already in the DOM — this only moves the `is-on` class, so the slot's
     width never changes and the headline never reflows.
     prefers-reduced-motion: freeze on the LAST word, which is the universal one. */
  (function () {
    var HOLD = 1500, HOLD_LAST = 4000, FADE = 220;

    function init(root) {
      var host = root.querySelector('[data-sb-rot]');
      if (!host) return;
      var items = host.querySelectorAll('[data-sb-rot-item]');
      var n = items.length;
      if (n < 2) return;

      function show(i) {
        for (var k = 0; k < n; k++) { items[k].classList.toggle('is-on', k === i); }
      }
      function hideAll() {
        for (var k = 0; k < n; k++) { items[k].classList.remove('is-on'); }
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce && reduce.matches) { show(n - 1); return; }

      var cycle = (n - 1) * HOLD + HOLD_LAST;
      var t0 = Date.now();
      var last = -1, lastVis = null;

      function tick() {
        var t = (Date.now() - t0) % cycle, i = 0;
        while (i < n - 1 && t >= HOLD) { t -= HOLD; i++; }
        var len = i === n - 1 ? HOLD_LAST : HOLD;
        var vis = t < len - FADE;
        if (i !== last) { last = i; if (vis) show(i); }
        if (vis !== lastVis) { if (vis) { show(last); } else { hideAll(); } lastVis = vis; }
      }

      show(0);
      tick();
      setInterval(tick, 100);
    }

    /* Mobile sticky bar — reveal once the hero CTA has scrolled out of view,
       so it never sits under the button it duplicates. */
    function sticky(root) {
      var bar = root.querySelector('[data-sb-sticky]');
      var cta = root.querySelector('.sb-hero__ctas');
      if (!bar || !cta) return;
      if (!('IntersectionObserver' in window)) { bar.setAttribute('data-sb-show', ''); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { bar.removeAttribute('data-sb-show'); }
          else if (en.boundingClientRect.top < 0) { bar.setAttribute('data-sb-show', ''); }
          else { bar.removeAttribute('data-sb-show'); }
        });
      }, { threshold: 0 }).observe(cta);
    }

    /* prefers-reduced-motion: hold the poster frame. CSS can't pause a video,
       and a looping hero is exactly the motion this setting asks us to stop. */
    function stillFootage(root) {
      var v = root.querySelector('[data-sb-hero-video]');
      if (!v) return;
      var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!mq || !mq.matches) return;
      v.removeAttribute('autoplay');
      v.autoplay = false;
      try { v.pause(); } catch (e) {}
    }

    function boot(root) { init(root); sticky(root); stillFootage(root); }

    document.querySelectorAll('.sb-hero').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('.sb-hero')) boot(e.target);
    });
  })();

;
// sb-reactions

  /* sb-reactions — one rail. In view = playing (muted); the pill or a tap
     gives ONE card its sound. Reduced motion = poster + play button. */
  (function () {
    function boot(root) {
      var rail = root.querySelector('[data-sb-rx-rail]');
      if (!rail) return;
      var cards = [].slice.call(root.querySelectorAll('[data-sb-rx-card]'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var onText = root.getAttribute('data-sound-on') || 'Sound on';
      var offText = root.getAttribute('data-sound-off') || 'Sound off';
      var loud = null;                         /* the one card with sound */
      /* how much of a card must be on screen before it plays: the standalone
         rail keeps 0.6; the hero passes 0.25 because its rail sits partly
         below the fold on phones and a still poster there looked broken
         (Ajinkya, 2026-09-23: "none of the videos on the homepage play") */
      var thr = parseFloat(root.getAttribute('data-sb-rx-threshold'));
      if (!(thr > 0 && thr < 1)) thr = 0.6;

      function video(c) { return c.querySelector('[data-sb-rx-video]'); }
      function pill(c) { return c.querySelector('[data-sb-rx-sound]'); }

      function setSound(c, on) {
        var v = video(c), b = pill(c), t = c.querySelector('[data-sb-rx-sound-t]');
        if (!v) return;
        v.muted = !on;
        if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on'); }
        if (t) t.textContent = on ? onText : offText;
        if (on) {
          if (loud && loud !== c) setSound(loud, false);
          loud = c;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (loud === c) { loud = null; }
      }

      function play(c) {
        var v = video(c); if (!v) return;
        var p = v.play();
        /* iOS Low Power Mode and some data-saver settings refuse programmatic
           play. Silently swallowing that left a frozen poster with nothing to
           tap — now the play button appears and one tap starts it. */
        if (p && p.catch) p.catch(function () { var pb = c.querySelector('[data-sb-rx-play]'); if (pb) pb.hidden = false; });
      }
      function pause(c) { var v = video(c); if (!v) return; v.pause(); if (loud === c) setSound(c, false); }

      cards.forEach(function (c) {
        var v = video(c), b = pill(c), pb = c.querySelector('[data-sb-rx-play]');
        if (!v) return;

        /* A missing transcoded asset falls back to the DEV placeholder, once. */
        var fb = v.getAttribute('data-sb-rx-fallback');
        if (fb && v.hasAttribute('data-sb-rx-asset')) {
          v.addEventListener('error', function onErr() {
            v.removeEventListener('error', onErr);
            var srcEl = v.querySelector('source'); if (srcEl) { srcEl.src = fb; v.load(); }
          }, true);
        }

        if (b) b.addEventListener('click', function (e) { e.stopPropagation(); setSound(c, v.muted); });
        c.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-sb-rx-sound],[data-sb-rx-play]')) return;
          if (reduce) { if (v.paused) { play(c); if (pb) pb.hidden = true; } else { v.pause(); if (pb) pb.hidden = false; } return; }
          setSound(c, v.muted);
        });
        if (pb) pb.addEventListener('click', function (e) { e.stopPropagation(); play(c); pb.hidden = true; });
        if (reduce && pb) pb.hidden = false;
      });

      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var c = en.target;
            if (en.isIntersecting && en.intersectionRatio >= thr) play(c); else pause(c);
          });
        }, { root: null, threshold: [0, thr] });
        cards.forEach(function (c) { io.observe(c); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) cards.forEach(pause); });

      /* desktop arrows */
      var prev = root.querySelector('[data-sb-rx-prev]'), next = root.querySelector('[data-sb-rx-next]');
      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 16 : 320; }
      function edges() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        if (prev) prev.disabled = rail.scrollLeft <= 0;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      edges();
    }
    function init() { [].forEach.call(document.querySelectorAll('[data-sb-rx]'), boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-sb-rx]'); if (r) boot(r); });
  })();

;
// sb-open

  /* sb-open — one phone, four gift pages. Every hold the photo crossfades and
     the text swaps; the bar runs the whole song length across one hold so it
     reads as playing. Reduced motion: first page, no cycling. Off screen: paused. */
  (function () {
    function boot(root) {
      var dataEl = root.querySelector('[data-sb-op-data]');
      var gifts = [];
      try { gifts = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { gifts = []; }
      var layers = [].slice.call(root.querySelectorAll('[data-sb-op-layer]'));
      var dots = [].slice.call(root.querySelectorAll('[data-sb-op-dot]'));
      var elFrom = root.querySelector('[data-sb-op-from]'), elTitle = root.querySelector('[data-sb-op-title]');
      var elMeta = root.querySelector('[data-sb-op-meta]'), elLine = root.querySelector('[data-sb-op-line]');
      var elBar = root.querySelector('[data-sb-op-bar]'), elEl = root.querySelector('[data-sb-op-elapsed]'), elLen = root.querySelector('[data-sb-op-length]');
      var hold = parseInt(root.getAttribute('data-hold'), 10) || 5000;
      var n = Math.min(gifts.length, layers.length);
      if (!n) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cur = 0, t0 = Date.now(), timer = null, visible = true, swapping = false;

      function toSecs(str) { var p = String(str || '').split(':'); if (p.length !== 2) return 180; return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0); }
      function fmt(sec) { sec = Math.max(0, Math.floor(sec)); var m = Math.floor(sec / 60), s = sec % 60; return m + ':' + (s < 10 ? '0' : '') + s; }

      function show(k, instant) {
        cur = k;
        layers.forEach(function (l, i) { l.classList.toggle('is-on', i === k); l.setAttribute('aria-hidden', i === k ? 'false' : 'true'); });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); d.setAttribute('aria-selected', i === k ? 'true' : 'false'); });
        var g = gifts[k];
        var apply = function () {
          if (elFrom) elFrom.textContent = g.from || '';
          if (elTitle) elTitle.textContent = g.title || '';
          if (elMeta) elMeta.textContent = g.meta || '';
          if (elLine) elLine.textContent = g.line || '';
          if (elLen) elLen.textContent = g.length || '';
          root.classList.remove('is-swapping'); swapping = false;
        };
        if (instant || reduce) { apply(); return; }
        root.classList.add('is-swapping'); swapping = true;
        setTimeout(apply, 380);
      }

      function tick() {
        if (!visible) return;
        var el = (Date.now() - t0) % hold;             /* ms into this hold */
        var len = toSecs(gifts[cur].length);
        var secs = el / hold * len;                     /* the whole song across one hold */
        if (elBar) elBar.style.width = (secs / len * 100).toFixed(1) + '%';
        if (elEl) elEl.textContent = fmt(secs);
        var k = Math.floor((Date.now() - t0) / hold) % n;
        if (k !== cur && !swapping) show(k, false);
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var k = parseInt(d.getAttribute('data-sb-op-dot'), 10) || 0;
          t0 = Date.now() - k * hold;                   /* align the clock so this page just started */
          show(k, false);
          if (elBar) elBar.style.width = '0%';
        });
      });

      if (reduce) { show(0, true); if (elBar) elBar.style.width = '35%'; if (elEl) elEl.textContent = fmt(toSecs(gifts[0].length) * 0.35); return; }

      function start() { if (timer) return; t0 = Date.now() - cur * hold; timer = setInterval(tick, 250); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = !!(es[0] && es[0].isIntersecting);
          if (visible) start(); else stop();
        }, { threshold: 0.2 }).observe(root);
      } else { start(); }
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (visible) start(); });
    }
    function init() { [].forEach.call(document.querySelectorAll('[data-sb-open]'), boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-sb-open]'); if (r) boot(r); });
  })();

;
// sb-listen

  (function () {
    function boot(root) {
      var audio = root.querySelector('[data-sb-ls-audio]');
      var current = null;
      function stop() { if (!current) return; current.removeAttribute('data-sb-ls-playing'); current = null; try { audio.pause(); } catch (e) {} }
      root.querySelectorAll('[data-sb-ls-play]').forEach(function (btn) {
        var song = btn.closest('[data-sb-ls-song]');
        btn.addEventListener('click', function () {
          if (current === song) { stop(); return; }
          stop();
          audio.src = btn.getAttribute('data-src');
          var p = audio.play(); if (p && p.catch) p.catch(function () {});
          song.setAttribute('data-sb-ls-playing', ''); current = song;
        });
      });
      audio.addEventListener('ended', stop);

      root.querySelectorAll('[data-sb-ls-chip]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var want = chip.getAttribute('data-sb-ls-chip');
          root.querySelectorAll('[data-sb-ls-chip]').forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          root.querySelectorAll('[data-sb-ls-song]').forEach(function (s) { s.hidden = !!want && s.getAttribute('data-style') !== want; });
        });
      });
    }
    document.querySelectorAll('.sb-ls').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-ls')) boot(e.target); });
  })();

;
// sb-pricing

  (function () {
    function boot(root) {
      var el = root.querySelector('[data-sb-pr-eta]');
      if (!el || !window.sbEta) return;
      el.textContent = window.sbEta(24).text;
    }
    document.querySelectorAll('.sb-pr').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-pr')) boot(e.target); });
  })();

;
// sb-reviews

  (function () {
    if (window.__sbRw) return; window.__sbRw = true;
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-sb-card]');
      if (!card || e.target.closest('a')) return;
      var row = card.closest('[data-sb-row]');
      var open = !card.classList.contains('is-open');
      if (row) row.querySelectorAll('[data-sb-card].is-open').forEach(function (c) { c.classList.remove('is-open'); });
      card.classList.toggle('is-open', open);
      if (row) row.classList.toggle('is-paused', open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('[data-sb-card]');
      if (card) { e.preventDefault(); card.click(); }
    });
  })();
